import React from 'react';

import useIsSignUpLandingVariantEnabled from '../../../common/hooks/useIsSignUpLandingVariantEnabled';
import { ROUTES } from '../../../common/routes';
import AuthPageMenuItemContent from './AuthPageMenuItemContent';
import HireLandingPageMenuItemContent from './HireLandingPageMenuItemContent';
import { MenuItemsWithLogoutAndContactSupport } from './MenuItemsWithLogoutAndContactSupport/MenuItemsWithLogoutAndContactSupport';

const DefaultAlterNativeNavbarContentBasedOnPathName: Record<
  string,
  {
    navbarContent: JSX.Element | undefined;
    sidebarContent?: JSX.Element;
    mobileContent?: JSX.Element;
  }
> = {
  [`/${ROUTES.onboarding}`]: {
    navbarContent: <MenuItemsWithLogoutAndContactSupport />,
  },
  [`/${ROUTES.emailVerification}`]: {
    navbarContent: <MenuItemsWithLogoutAndContactSupport />,
  },

  [`/${ROUTES.companyReportStatus}`]: {
    navbarContent: <MenuItemsWithLogoutAndContactSupport />,
  },

  [`/${ROUTES.login}`]: {
    navbarContent: <AuthPageMenuItemContent.NavbarContent />,
    sidebarContent: <AuthPageMenuItemContent.SidebarContent />,
  },
  [`/${ROUTES.signup}`]: {
    navbarContent: <AuthPageMenuItemContent.NavbarContent />,
    sidebarContent: <AuthPageMenuItemContent.SidebarContent />,
  },
  [`/${ROUTES.hire}`]: {
    navbarContent: <HireLandingPageMenuItemContent.NavbarContent />,
    sidebarContent: <HireLandingPageMenuItemContent.SidebarContent />,
    mobileContent: <HireLandingPageMenuItemContent.MobileContent />,
  },
};
export default function useGetAlternativeHeaderContent() {
  const isSignUpLandingVariantEnabled = useIsSignUpLandingVariantEnabled();
  const content = isSignUpLandingVariantEnabled
    ? {
        ...DefaultAlterNativeNavbarContentBasedOnPathName,
        [`/`]: {
          navbarContent: <AuthPageMenuItemContent.NavbarContent />,
          sidebarContent: <AuthPageMenuItemContent.SidebarContent />,
        },
      }
    : DefaultAlterNativeNavbarContentBasedOnPathName;
  return content;
}
